// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__vojGq","spinner":"Loader_spinner__iDFIv","item":"Loader_item__iys6Z","spinner1":"Loader_spinner1__z64Gg"};